<template>
  <div>
    <ag-company-select
      @change="onCompanyChange"
      :company-data="selectedCompany"
      v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin]"
      class="mb-3"
    ></ag-company-select>
    <ag-site-select
      v-if="selectedCompany"
      :company="selectedCompany"
      @change="onSiteChange"
      :key="compKey"
      :site="selectedSite"
      @groupLoaded="onGroupLoaded"
      v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.SiteAdmin]"
      class="mb-3"
    ></ag-site-select>
    <ag-group-select
      v-if="selectedSite"
      :group="value"
      :selected-groups-data="selectedGroupsData"
      :site="selectedSite"
      v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.SiteAdmin]"
      :type="type"
      @change="onGroupChange"
    ></ag-group-select>
  </div>
</template>

<script>
import { Roles } from "@/helpers/enums/Roles";
import AgSiteSelect from "./ag-site-select.vue";
import AgGroupSelect from "./ag-group-select.vue";
import AgCompanySelect from "./ag-company-select.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AgSiteSelect,
    AgGroupSelect,
    AgCompanySelect,
  },
  props: {
    selectedCompanyData: {},
    selectedSiteData: {},
    selectedGroupsData: {},
    value: {
      type: String,
    },
    type: {
      type: String,
      default: "single",
    },
  },
  data() {
    return {
      Roles: Roles,
      selectedGroups: [],
      selectedSite: null,
      selectedCompany: null,
      compKey: 0,
      compKeyGroup: 0,
    };
  },
  computed: {
    ...mapGetters(["company", "site"]),
  },
  watch: {
    company(value) {
      this.selectedCompany = this.company ? this.company : null;
    },
    selectedSiteData(value) {
      this.selectedSite = value;
    },
    selectedGroupsData(value) {
      this.selectedGroups = value;
    },
    selectedCompanyData(value) {
      this.selectedCompany = value;
    },
  },
  mounted() {
    if (this.company) {
      this.selectedCompany = this.company;
    }
    if (this.site) {
      this.selectedSite = this.site;
    }
  },
  methods: {
    clearSite(item) {
      this.selectedSite = null;
    },
    clearCompany(item) {
      this.selectedCompany = null;
    },
    onCompanyChange(data) {
      this.selectedCompany = data;
      this.$emit("companyChange", data);
      this.$emit("change", {
        type: "company",
        data: {
          value: data ? data.value : null,
          label: data ? data.label : null,
          title: "Company",
          key: "CompanyGuid",
        },
      });
      ++this.compKey;
    },
    onSiteChange(data) {
      this.selectedSite = data;
      this.$emit("siteChange", data);
      this.$emit("change", {
        type: "site",
        data: {
          value: data ? data.value : null,
          label: data ? data.label : null,
          title: "Site",
          key: "SiteGuid",
        },
      });
      ++this.compKeyGroup;
    },
    onGroupChange(data) {
      this.selectedGroups = data;
      this.$emit("change", {
        type: "group",
        data: data,
      });
    },
    onGroupLoaded(data) {
      if (this.selectedGroups.length === 0) {
        const groupData = data.map((e) => {
          return {
            label: e.name,
            value: e.groupGuid,
            version: e.policyDistributedVersion,
          };
        });
        this.$emit("changeOnAllGroup", groupData);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
